module.exports = __webpack_public_path__ + "img/community_code_bottom.a9bdf8fe.png";